import { FlagBannerFold } from "@phosphor-icons/react";

import usePromotions from "common/datahooks/usePromotions";

import ManagePromotion from "./ManagePromotions/ManagePromotion";

export default function LifetimeSeats() {
  const { ltdPromotion, appSumoPromotion } = usePromotions();

  return (
    <>
      <div className="justify-end flex gap-x-2 max-lg:w-full">
        {!!appSumoPromotion && <ManagePromotion promotion={appSumoPromotion} />}
        {!!ltdPromotion && <ManagePromotion promotion={ltdPromotion} />}
      </div>
      <div className="p-4 flex gap-x-3 border border-black-200 rounded-3xl items-center">
        <div className="flex size-12 rounded-3xl bg-[linear-gradient(132deg,#DCE1EA_-4.58%,#FFF_85.29%)] shadow-[0_0_2px_2px_rgba(255,255,255,0.16)_inset,0_3px_6px_2px_rgba(17,24,39,0.20),0_0_0_3px_rgba(243,244,246,0.50),0_28px_20px_0_rgba(239,239,239,0.70)]">
          <FlagBannerFold weight="fill" className="size-6 m-auto" />
        </div>
        <div className="flex flex-col gap-y-0.5">
          <span className="text-lg-bold">Lifetime seats</span>
          <p className="text-sm-medium text-black-500">
            Manage your available lifetime seats across workspaces{" "}
          </p>
        </div>
        <div className="flex items-end gap-x-0.5 ml-auto mb-auto">
          <span className="text-lg-bold">
            {(ltdPromotion?.license_count ?? 0) +
              (appSumoPromotion?.license_count ?? 0)}
          </span>
          <span className="text-black-500 text-sm-medium pb-0.5">seats</span>
        </div>
      </div>
      <div />
    </>
  );
}
